import React, { FC } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import rotatingGears from "@/assets/lottie/rotating-gears.lottie?url";
import { Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import IconTileContentLayout from "js/components/StudentTile/components/IconTileContentLayout";

const StudentReconnecting: FC = () => {
	const { t } = useTranslation();
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} height={tileSize !== "sm" ? "100%" : ""}>
			<IconTileContentLayout>
				<DotLottieReact
					src={rotatingGears}
					loop
					autoplay
					renderConfig={{ autoResize: true, freezeOnOffscreen: false }}
					style={{
						width: tileSize !== "sm" ? "64px" : "45px",
						height: tileSize !== "sm" ? "71px" : "40px",
					}}
				/>
				<Text mt={4} fontWeight={"bold"}>
					{t("studentTile.reconnectingTitle")}
				</Text>
				<Text>{t("studentTile.reconnectingSubtitle")}</Text>
			</IconTileContentLayout>
		</Flex>
	);
};

export default StudentReconnecting;
